import React from 'react';

export default function PayslipSummaryCards({ summary, month, year }) {
  const formatCurrency = (val) => {
    const num = Number(val || 0);
    return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const cards = [
    {
      label: 'Gross Earnings',
      value: formatCurrency(summary?.grossEarnings),
      subtext: `${summary?.earningsCount || 0} Earning Heads`,
      icon: 'trending_up',
      color: 'text-emerald-600',
      bg: 'bg-emerald-500/10',
    },
    {
      label: 'Total Deductions',
      value: formatCurrency(summary?.totalDeductions),
      subtext: `${summary?.deductionsCount || 0} Statutory / Voluntary`,
      icon: 'trending_down',
      color: 'text-rose-600',
      bg: 'bg-rose-500/10',
    },
    {
      label: 'Net Payable Salary',
      value: formatCurrency(summary?.netSalary),
      subtext: `${month || 'Current'} ${year || ''} Statement`,
      icon: 'account_balance_wallet',
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
    {
      label: 'Pay Heads Count',
      value: String(summary?.totalPayheads || 0),
      subtext: 'Mapped Salary Components',
      icon: 'receipt_long',
      color: 'text-indigo-600',
      bg: 'bg-indigo-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-5 shadow-xs transition-all hover:shadow-sm"
        >
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">
              {card.label}
            </span>
            <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${card.bg} ${card.color}`}>
              <span className="material-symbols-outlined text-lg">{card.icon}</span>
            </div>
          </div>
          <div className="mt-3">
            <span className="font-sans text-2xl font-extrabold text-on-surface tabular-nums tracking-tight">
              {card.value}
            </span>
            <p className="text-[11px] font-semibold text-slate-500 mt-0.5">{card.subtext}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
